import { el } from 'redom';

import application from 'application';
import internalEventCodes from 'event-system/codes/internal';

class EndedPollChoice {

  constructor() {

    this.nameEl = el('.ended-poll-choice-name');
    this.votePercentageEl = el('.ended-poll-choice-vote-percentage');

    const textDataContainer = el('.poll-choice-details-container.two-column', [this.nameEl, this.votePercentageEl]);
    this.percentageDisplay = el('.poll-choice-percentage-bar');

    this.el = el('li.ended-poll-choice-item', [this.percentageDisplay, textDataContainer]);

    this.el.addEventListener('click', this.handleChoiceButtonClick.bind(this));

  }

  handleChoiceButtonClick(event) {

    event.stopPropagation();

    if (application.isAuthenticated() === false) {
      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_AUTHENTICATOR);
      return;
    }

  }

  update(choice, index, items, context) {

    let votePercentage = Math.floor((choice.votesCount / context.poll.totalVotesCount) * 100);

    if (isNaN(votePercentage) === true) {
      votePercentage = 0;
    }

    this.nameEl.textContent = choice.name;
    this.votePercentageEl.textContent = votePercentage + '%';
    this.percentageDisplay.style.width = votePercentage + '%';

  }

}

export default EndedPollChoice;